import determineHomeErrorText from "./determine_home_error_text";

export const editHomeAmounts = (newHome, currentHome, totalOneTimeCosts, changeType,
    downPaymentMax, totalSavingsAmt, monthlyIncomeMinusHomeCosts, 
    monthlyIncomeMinusRoommateAmts, totalMonthlyCost, creditScore ) => {
    let amountErrorText1 = "";
    let amountErrorText2 = "";
    let amtError = false;
    let errorType = "";
    let errorTextObj = {};
    let downPaymentAmt = newHome.DownPaymentAmt;
    if (isNaN(downPaymentAmt)){
        downPaymentAmt = 0;
    }
    if (+newHome.totLoanAmt > 0 && +downPaymentAmt === 0){
        if (newHome.HomeType === "house" && changeType !== "roommate-change"){ 
             if (isNaN(newHome.DownPaymentAmt)){
                    amountErrorText1 = "Down Payment Must be Numeric (no commas or $).";
                    errorType = "critical";
             }else{
                if (+newHome.DownPaymentAmt === 0){
                    amountErrorText1 = "Down Payment Amount is required and cannot be 0.";
                    errorType = "critical";
                }else{
                    newHome.DownPaymentPct = ((+newHome.DownPaymentAmt / 
                        +newHome.HomeFullCost)  * 100).toFixed(3);
                    if (newHome.DownPaymentPct < 5){
                        amountErrorText1 = "Down Payment Amount must be greater than 5%";
                        errorType = "critical";
                    }
                    if (+newHome.DownPaymentAmt > +downPaymentMax){
                        amountErrorText1 = "Down Payment Amount exceeds amount available.";
                        errorType = "critical";
                    }
                }
            }
            if (errorType === "critical"){
                amountErrorText2 = "Enter/correct the down payment amount and then click " +
                "the 'Submit' or 'Accept/Continue' button."
            }
        }
    }
    if (errorType === ""){
        //  totalOneTimeCosts will be negative if profit from sale of current home exceeds other costs
        if (+currentHome.CashAmt < +totalOneTimeCosts){
            let errorTextObj = {};
            if (newHome.HomeType === "apartment"){
                errorTextObj = determineHomeErrorText("notEnoughCash");
                amountErrorText1 = errorTextObj.text;
                errorType = errorTextObj.errorType;
                amtError = true;
            }
            if (newHome.HomeType === "house" && +newHome.DownPaymentAmt >= +currentHome.CashAmt){
                errorTextObj = determineHomeErrorText("transferCashLit1");
                amountErrorText1 = errorTextObj.text;
                errorType = errorTextObj.errorType;
                amtError = true;
                if (totalSavingsAmt > 0 ){
                    errorTextObj = determineHomeErrorText("transferCashLit2");
                    amountErrorText2 = errorTextObj.text;
                    errorType = errorTextObj.errorType;
                }
            }
            if (newHome.HomeType === "house" && newHome.DownPaymentAmt > downPaymentMax){
                errorTextObj = determineHomeErrorText("notEnoughCashDownPayment");
                amountErrorText1 = errorTextObj.text;
                amountErrorText2 = "";
                errorType = errorTextObj.errorType;
                amtError = true;
            }
        }
        let monthlyIncome = monthlyIncomeMinusHomeCosts;
        if (changeType === "roommate-change"){
            monthlyIncome = monthlyIncomeMinusRoommateAmts;
        }
        if (totalMonthlyCost > monthlyIncome &&
            newHome.RoommateShareOfMortgage < monthlyIncome){ 
            if (changeType === "roommate-change" ||
                newHome.HomeType !== "house"){
                    if (changeType === "apartment-apartment" &&
                        currentHome.FullRentAmt >= newHome.FullRentAmt){
                        errorTextObj = determineHomeErrorText("monthlyIncomeError");
                        amountErrorText1 = errorTextObj.text;
                        errorType = errorTextObj.errorType;
                    }else{
                        errorTextObj = determineHomeErrorText("monthlyIncomeErrorOK");
                        amountErrorText1 = errorTextObj.text;
                        amountErrorText2 = "";
                        errorType = errorTextObj.errorType;
                    }
            }else{ 
                if (newHome.DownPaymentAmt !== 0){
                    errorTextObj = determineHomeErrorText("loanNotApprovedIncome");
                    amountErrorText1 = errorTextObj.text;
                    amountErrorText2 = "";
                    errorType = errorTextObj.errorType;
                }
            }
        }
        //  if downpayment amount is less than total cost of home, then need to ensure that
        //  loan is viable due to credit score
        if (newHome.DownPaymentAmt < downPaymentMax){
            if (creditScore <= 620){
                errorTextObj = 
                    determineHomeErrorText("loanNotApprovedCreditScore", "creditScore", creditScore);
                amountErrorText1 = errorTextObj.text;
                amountErrorText2 = "";
                errorType = errorTextObj.errorType;
            }
        }
    }
    if (errorType !== ""){
        amtError = true;
    }
    const returnObj = {amtError: amtError, amountErrorText1: amountErrorText1,
        amountErrorText2: amountErrorText2, errorType: errorType
    }
    return returnObj;
}
export default editHomeAmounts;